import React, { memo } from 'react';

import Text from './Text';

const Integer = (props) => {
    return <Text {...props} className="fm-field-number" hint="0" type="integer" />;
};

export default memo(Integer);
